import { getDataMapper, mapArray, mapField } from "@/shared";

const mapStats = getDataMapper({
    recipients: mapField("recipients", Number),
    sent: mapField("sent", Number),
    failed: mapField("failed", Number),
    opened: mapField("opened", Number),
    clicked: mapField("clicked", Number),
    unsubscribed: mapField("unsubscribed", Number),
    bounced: mapField("bounced", Number),
    openRate: mapField("open_rate", Number),
    clickRate: mapField("click_rate", Number),
    unsubscribeRate: mapField("unsubscribe_rate", Number),
    bounceRate: mapField("bounce_rate", Number),
});

export const mapCampaignFromServer = getDataMapper({
    id: mapField("id", Number),
    name: mapField("name"),
    subject: mapField("subject"),
    fromName: mapField("from_name"),
    fromEmail: mapField("from_email"),
    template: mapField("template"),
    bodyHtml: mapField("body_html"),
    segmentJson: mapField("segment_json"),
    directorIds: mapField("director_ids"),
    status: mapField("status"),
    isEditable: mapField("is_editable", Boolean),
    throttlePerMinute: mapField("throttle_per_minute", Number),
    scheduledAt: mapField("scheduled_at"),
    startedAt: mapField("started_at"),
    finishedAt: mapField("finished_at"),
    stats: mapField("stats", mapStats),
    createdAt: mapField("created_at"),
    updatedAt: mapField("updated_at"),
});

export const mapCampaignsFromServer = mapArray(mapCampaignFromServer);
